import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AuthService } from '@s-services/auth.service';

@Component({
    selector: 'app-not-verified',
    templateUrl: './not-verified.component.html',
    styleUrls: ['./not-verified.component.scss'],
    imports: [],
})
export class NotVerifiedComponent implements OnInit, OnDestroy {

  checkEmailVerificationInterval: ReturnType<typeof setInterval> | undefined;

  constructor(public authService: AuthService,
    private snackbar: MatSnackBar) {
  }

  ngOnInit() {
    this.checkEmailVerificationInterval = setInterval(() => {
      this.authService.checkEmailVerification();
    }, 5000);
  }

  ngOnDestroy() {
    clearInterval(this.checkEmailVerificationInterval);
  }

  onSendEmailVerification() {
    this.authService.sendEmailVerification().then(() => {
      this.snackbar.open('Email versand!', 'Ok', { duration: 3000 });
    }).catch(error => {
      this.snackbar.open(error, 'Ok', { duration: 3000 });
    });
  }
}
